import * as customersCreationApi from '@/network/api/customers/creation.api.js'
import * as apiAgencies from '@/network/api/agencies.api.js'
import * as apiBranches from '@/network/api/branches.api.js'

/** requests steps info and its status
@return {promise} - steps info and its status response
*/
export const getStepsListInfo = async (context, payload) => {
    const res = await customersCreationApi.getStepsListInfo(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_PROCESS_STEPS_INFO', data)
    }
    return res
}

/** starts the creation account process
@return {promise} - creation account process response
*/
export const startCreateAccountProcess = async (context, payload) => {
    const res = await customersCreationApi.startCreateAccountProcess(payload)
    return res
}

/** sends OTP validation
@return {promise} - send valitation OTP response
*/
export const sendValitationOTP = async (context, payload) => {
    const res = await customersCreationApi.sendValitationOTP(payload)
    return res
}

/** resends OTP validation
@return {promise} - resend valitation OTP response
*/
export const resendValitationOTP = async (context, payload) => {
    const res = await customersCreationApi.resendValitationOTP(payload)
    return res
}

/** validate OTP
@return {promise} - validate OTP response
*/
export const validateOTP = async (context, payload) => {
    const res = await customersCreationApi.validateOTP(payload)
    return res
}

/** Create Document
@return {promise} -
*/
export const createDocument = async (context, payload) => {
    const res = await customersCreationApi.createDocument(payload)
    return res
}

/** Delete Document
@return {promise} -
*/
export const deleteDocument = async (context, payload) => {
    const res = await customersCreationApi.deleteDocument(payload)
    return res
}

/** Process documents and returns their info
@return {promise} - process documents and returns their info
*/
export const processDocumentsInfo = async (context, payload) => {
    const res = await customersCreationApi.processDocumentsInfo(payload)
    return res
}

/** Update Create Account Process info
@return {promise} - request response
*/
export const updateCreateAccountProcessInfo = async (context, payload) => {
    const res = await customersCreationApi.updateCreateAccountProcessInfo(payload)
    return res
}

/** Validate Document Number
@return {promise} - request response
*/
export const validateDocument = async (context, payload) => {
    const res = await customersCreationApi.validateDocument(payload)
    return res
}

/** requests literary abilities for create account process
@return {promise} - requests literary abilities response
*/
export const requestLiteraryAbilities = async (context, payload) => {
    const res = await customersCreationApi.getLiteraryAbilities(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_LITERARY_ABILITIES', data)
    }
    return res
}

/** requests marital status for create account process
@return {promise} - request marital status response
*/
export const requestMaritalStatus = async (context, payload) => {
    const res = await customersCreationApi.getMaritalStatus(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_PROCESS_MARITAL_STATUS', data)
    }
    return res
}

/** requests countries for create account process
@return {promise} - request countries response
*/
export const requestCountries = async (context, payload) => {
    const res = await customersCreationApi.getCountries(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_PROCESS_COUNTRIES', data)
    }
    return res
}

/** requests provinces for create account process
@return {promise} - request provinces response
*/
export const requestProvinces = async (context, payload) => {
    const res = await customersCreationApi.getProvinces(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_PROCESS_PROVINCES', data)
    }
    return res
}

/** requests counties for create account process
@return {promise} - request counties response
*/
export const requestCounties = async (context, payload) => {
    const res = await customersCreationApi.getCounties(payload)
    if (res) {
        const data = res.data.data
        if (payload) context.commit('SAVE_PROCESS_PROVINCE_COUNTIES', data)
        else context.commit('SAVE_PROCESS_COUNTIES', data)
    }
    return res
}

/** requests occupations for create account process
@return {promise} - request occupations response
*/
export const requestProcessOccupation = async (context, payload) => {
    const res = await customersCreationApi.getProcessOccupation(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_PROCESS_OCCUPATION', data)
    }
    return res
}

/** requests professions for create account process
@return {promise} - request professions response
*/
export const requestProfessions = async (context, payload) => {
    const res = await customersCreationApi.getProfessions(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_PROCESS_PROFESSIONS', data)
    }
    return res
}

/** requests contractual ties for create account process
@return {promise} - request contractual ties response
*/
export const requestContractualTies = async (context, payload) => {
    const res = await customersCreationApi.getContractualTies(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_PROCESS_CONTRACTUAL_TIES', data)
    }
    return res
}

/** requests professional activities for create account process
@return {promise} - request professional activities  response
*/
export const requestProfessionalActivities = async (context, payload) => {
    const res = await customersCreationApi.getProfessionalActivities(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_PROCESS_ACTIVITIES', data)
    }
    return res
}

/** uploads supporting document for create account process
@return {promise} - upload supporting document for create account process
*/
export const uploadSupportingDocument = async (context, payload) => {
    const res = await customersCreationApi.uploadSupportingDocument(payload)
    return res
}

/** request submit of interview video
@return {promise} - request submit of interview video response
*/
export const submitInterviewVideo = async (context, payload) => {
    const res = await customersCreationApi.submitInterviewVideo(payload)
    return res
}

/** request delete of submited interview video
@return {promise} - request delete of submited interview video response
*/
export const deleteSubmitedInterviewVideo = async (context, payload) => {
    const res = await customersCreationApi.deleteSubmitedInterviewVideo(payload)
    return res
}

/** requests agencies provinces
@return { promise } - Agencies Provinces request
*/
export const requestAgenciesProvinces = async (context, payload) => {
    const res = await apiAgencies.requestNonAuthenticatedAgenciesProvinces(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_PROCESS_AGENCIES_PROVINCES', data)
    }
    return res
}

/** requests branches
@return {promise} - request branches response
*/
export const requestBranches = async (context, payload) => {
    const res = await customersCreationApi.getBranchList(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_PROCESS_BRANCHES', data)
    }
    return res
}

/** Submit final step for Account Process info
@return {promise} - request submit final step for Account Process info response
*/
export const submitCreateAccountProcessInfo = async (context, payload) => {
    const res = await customersCreationApi.submitCreateAccountProcessInfo(payload)
    return res
}

/** Resend password for Account Process info
@return {promise} - request resend password for Account Process info response
*/
export const resendPassword = async (context, payload) => {
    const res = await customersCreationApi.resendPassword(payload)
    return res
}
